import { useRef, useState, useEffect } from "react";
import ImageUploader from "../../../../../../../../GlobalComponents/ImageUploader/ImageUploader";
import { Actions } from "../../../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../../../Utils/storeUtils";
import NewPopup from "../../../../../../../../GlobalComponents/Popup/NewPopup";
import getAuthorizationHeader from "../../../../../../../../Utils/roconConstants";
import axios from "axios";

const EditOrgImage = (props) => {
  const { uploadImg, image, setUploadImg, loading, orgId, setLoading } = props;
  const fileInputRef = useRef(null);
  const [uploadFile, setUploadFile] = useState();
  const [imagePreview, setImagePreview] = useState(image || null);
  const [delLoading, setDelLoading] = useState(false);

  useEffect(() => {
    if (uploadFile) {
      let imageUrl = URL.createObjectURL(uploadFile);
      setImagePreview(imageUrl);
    }
  }, [uploadFile]);

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      setUploadFile(file);
    }
  };

  const handleUpload = () => {
    if (!uploadFile) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("orgId", orgId);

    axios
      .post(
        `${process.env.REACT_APP_BACK_END_API_BASE_URL}/organizations/orgImageUpload`,
        formData,
        getAuthorizationHeader()
      )
      .then(() => {
        getStore().dispatch({
          type: Actions.API_GET_SELECTED_ORG_FULL_INFO,
          orgId: orgId,
        });
        setLoading(false);
        setUploadImg(false);
      })
      .catch(() => {
        getStore().dispatch({
          type: Actions.API_GET_SELECTED_ORG_FULL_INFO,
          orgId: orgId,
        });
        setLoading(false);
        setUploadImg(false);
      });
  };

  const handleDelete = () => {
    setDelLoading(true);
    axios
      .delete(
        `${process.env.REACT_APP_BACK_END_API_BASE_URL}/organizations/deleteOrgImage?orgId=${orgId}`,
        getAuthorizationHeader()
      )
      .then(() => {
        getStore().dispatch({
          type: Actions.API_GET_SELECTED_ORG_FULL_INFO,
          orgId: orgId,
        });
        setDelLoading(false);
        setImagePreview(null);
        setUploadImg(false);
      })
      .catch(() => {
        getStore().dispatch({
          type: Actions.API_GET_SELECTED_ORG_FULL_INFO,
          orgId: orgId,
        });
        setDelLoading(false);
      });
  };

  const flushStateVariables = () => {
    setUploadImg(false);
    setDelLoading(false);
    setLoading(false);
    setImagePreview(image);
    setUploadFile(null);
  };

  return (
    <NewPopup
      trigger={uploadImg}
      closePopup={() => flushStateVariables()}
      header={"Edit Organization Image"}
      backPopup="Cancel"
      backOnClick={() => {
        flushStateVariables();
      }}
      nextpopup={"Save"}
      nextOnClick={() => {
        handleUpload();
      }}
      loading={loading}
      disabled={!uploadFile}
    >
      <ImageUploader
        imagePreview={imagePreview}
        defaultImage={image || "/path/to/default/image.png"}
        loading={delLoading}
        onDelete={handleDelete}
        onUploadClick={() => fileInputRef.current.click()}
        onFileChange={handleFileChange}
        fileInputRef={fileInputRef}
      />
    </NewPopup>
  );
};

export default EditOrgImage;
